module.exports = __webpack_public_path__ + "img/path.c36d7275.svg";